import React from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

import ProductPreview from '../../../component/productPreview/ProductPreview';
import UserPreview from '../../../component/userPreview/UserPreview';
import {myPageUrl, sellerUrl} from '../../../util/url';
import ReviewReply from './ReviewReply';
import ReviewRating from './ReviewRating';

import './ReviewItem.css';
import {reviewDateLabel} from '../../../util/util';

export default function ReviewItem({ currentUserId, review, seller }) {
    const reviewerUrl = currentUserId === review.user.id ? myPageUrl() : sellerUrl(review.user);

    return (
        <li className="Review-item">
            <Link className="Review-item-reviewer-image" to={reviewerUrl}>
                <UserPreview user={review.user} />
            </Link>

            <div className="Review-item-body">
                <div className="Review-item-main">
                    <div className="Review-item-content">
                        <Link className="Review-item-reviewer" to={reviewerUrl}>
                            <span className="Review-item-reviewer-nickname font-nhaasgrotesk">
                                {review.user.nickname}
                            </span>
                            {review.product?.title && (
                                <span className="Review-item-product-title">
                                    {review.product.title}
                                </span>
                            )}
                        </Link>

                        <div className="Review-item-meta">
                            <ReviewRating rating={review.rating} />
                            <span className="Review-item-meta-separator" aria-hidden="true">
                                ·
                            </span>
                            <time className="Review-item-date" dateTime={review.createdAt}>
                                {reviewDateLabel(review.createdAt)}
                            </time>
                        </div>

                        <p className="Review-item-text">
                            {review.text}
                        </p>
                    </div>

                    <div className="Review-item-product">
                        <ProductPreview product={review.product} width="180" height="180" soldLayer={false}/>
                    </div>
                </div>

                <ReviewReply review={review} seller={seller} />
            </div>
        </li>
    );
}
ReviewItem.propTypes = {
    currentUserId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    review: PropTypes.shape({
        id: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]).isRequired,
        text: PropTypes.string,
        rating: PropTypes.number,
        createdAt: PropTypes.string,
        product: PropTypes.shape({
            title: PropTypes.string
        }),
        user: PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string
            ]).isRequired,
            nickname: PropTypes.string.isRequired,
            resizedSmallImage: PropTypes.string
        }).isRequired
    }).isRequired,
    seller: PropTypes.shape({
        is_certified: PropTypes.bool,
        user: PropTypes.shape({
            nickname: PropTypes.string,
            resizedSmallImage: PropTypes.string
        })
    }).isRequired,
};
